import React from "react";
import CTASection from "../CTASection/CTASection";
import styles from "./IndustrialSolutions.module.css";
import industrialBg from "../../../../images/InfraBG.jpg";

export default function IndustrialSolutions() {
  return (
    <section className={styles.section} id="industrial">
      <div className={styles.imageArea}>
        <img
          className={styles.bgImage}
          src={industrialBg}
          alt="Industrial solutions and smart infrastructure"
          loading="lazy"
        />
        <div className={styles.overlay} aria-hidden="true" />
        <div className={styles.content}>
          <div className={styles.inner}>
            <span className={styles.eyebrow}>Industrial Solutions</span>
            <h2 className={styles.title}>Industrial Solutions</h2>
            <p className={styles.description}>
              Committed to help building a smarter infrastructure
            </p>
          </div>
        </div>
      </div>
      <CTASection
        title="Know more about Industrial Solutions"
        description="Committed to help building a smarter infrastructure"
        label="Know More..."
        subLabel="about IS"
        href="/industrial-solutions"
      />
    </section>
  );
}
